import React from 'react'
import style from './JobItem.module.css'

export default function JobItem({ jobDetails }) {
    return (<div className={`${style.point} ml-[4.1rem] `}>
        <h4 className='text-[#19284D] font-medium text-lg'>{jobDetails.role}</h4>
        <p className='text-[#19284D]'>{jobDetails.companyName} <span className='font-light'>({jobDetails.type})</span></p>
        <p className='text-[#0369E4]'>{jobDetails.duration}</p>
        <div className='text-[#2f4e80]'>
            <ul className='list-disc list-inside space-y-1'>
                {jobDetails.description.map((descriptionjob, index) => <li key={(index+5)*200}>{descriptionjob}</li>)}
            </ul>
        </div>
    </div>)
}
